module.exports = __webpack_public_path__ + "static/img/Taiwan_04.50e63471.jpg";